import uuidv4 from 'uuid/v4';

export const defaultFolderObj = () => {
    return {
        configuration: [],
        createdAt: {
            date: '2019-09-20 15:15:15.000000'
        },
        description: '',
        files: [],
        id: 123,
        isEmphasized: false,
        infos: [],
        isInfo: false,
        modifiedAt: {
            date: '2019-09-20 15:15:15.000000'
        },
        name: '',
        persons: [],
        priority: 3,
        tags: [],
        topics: [],
        uniqueId: null,
        uuid: uuidv4(),
        overall: ''
    }
}